import React from 'react';

const DataViewerModal = ({ isOpen, onClose, data }) => {
  if (!isOpen || !data) return null;

  // Helper function to format keys for display
  const formatKey = (key) => {
    const keyMap = {
      orderCode: "رقم الطلب",
      workDescription: "وصف العمل",
      district: "المنطقة",
      contractor: "المقاول",
      consultant: "المستشار",
      office: "المكتب",
      situation: "الحالة",
      createAt: "تاريخ البدء",
      completionDate: "تاريخ الانتهاء",
      durationOfImplementation: "مدة التنفيذ",
      estimatedValue: "القيمة المقدرة",
      projectType: "نوع المشروع",
      workOrderType: "نوع أمر العمل",
      workLocation: "موقع العمل",
      workScope: "نطاق العمل",
      workStatus: "حالة العمل",
      workProgress: "تقدم العمل",
      workNotes: "ملاحظات العمل",
      workAttachments: "مرفقات العمل",
      workHistory: "سجل العمل",
      workComments: "تعليقات العمل",
      workApprovals: "موافقات العمل",
      workRejections: "رفض العمل",
      workChanges: "تغييرات العمل",
      workDelays: "تأخيرات العمل",
      workCosts: "تكاليف العمل",
      workPayments: "مدفوعات العمل",
      workInvoices: "فواتير العمل",
      workContracts: "عقود العمل",
      workPermits: "تصاريح العمل",
      workInspections: "فحوصات العمل",
      workReports: "تقارير العمل",
      workPhotos: "صور العمل",
      workDrawings: "رسومات العمل",
      workSpecifications: "مواصفات العمل",
      workMaterials: "مواد العمل",
      workEquipment: "معدات العمل",
      workPersonnel: "موظفي العمل",
      workSchedule: "جدول العمل",
      workMilestones: "معالم العمل",
      workRisks: "مخاطر العمل",
      workIssues: "مشاكل العمل",
      workSolutions: "حلول العمل",
      workRecommendations: "توصيات العمل",
      workLessons: "دروس العمل",
      workImprovements: "تحسينات العمل",
      workFeedback: "ملاحظات العمل",
      workRating: "تقييم العمل",
      workQuality: "جودة العمل",
      workSafety: "سلامة العمل",
      workEnvironment: "بيئة العمل",
      workSustainability: "استدامة العمل",
      workInnovation: "ابتكار العمل",
      workExcellence: "تميز العمل",
      workLeadership: "قيادة العمل",
      workTeamwork: "عمل الفريق",
      workCommunication: "تواصل العمل",
      workCoordination: "تنسيق العمل",
      workIntegration: "تكامل العمل",
      workOptimization: "تحسين العمل",
      workEfficiency: "كفاءة العمل",
      workEffectiveness: "فعالية العمل",
      workProductivity: "إنتاجية العمل",
      workPerformance: "أداء العمل",
      workResults: "نتائج العمل",
      workOutcomes: "مخرجات العمل",
      workImpacts: "تأثيرات العمل",
      workBenefits: "فوائد العمل",
      workValue: "قيمة العمل",
      workReturn: "عائد العمل",
      workInvestment: "استثمار العمل",
      workCost: "تكلفة العمل",
      workBudget: "ميزانية العمل",
      workFinance: "تمويل العمل",
      workFunding: "تمويل العمل",
      workSponsorship: "رعاية العمل",
      workPartnership: "شراكة العمل",
      workCollaboration: "تعاون العمل",
      workAlliance: "تحالف العمل",
      workNetwork: "شبكة العمل",
      workCommunity: "مجتمع العمل",
      workStakeholders: "أصحاب المصلحة في العمل",
      workCustomers: "عملاء العمل",
      workUsers: "مستخدمي العمل",
      workBeneficiaries: "مستفيدي العمل",
      workAudience: "جمهور العمل",
      workPublic: "عامة العمل",
      workSociety: "مجتمع العمل",
      workWorld: "عالم العمل",
      workUniverse: "كون العمل",
      workExistence: "وجود العمل",
      workReality: "واقع العمل",
      workTruth: "حقيقة العمل",
      workWisdom: "حكمة العمل",
      workKnowledge: "معرفة العمل",
      workUnderstanding: "فهم العمل",
      workInsight: "بصيرة العمل",
      workVision: "رؤية العمل",
      workMission: "مهمة العمل",
      workPurpose: "غرض العمل",
      workGoal: "هدف العمل",
      workObjective: "هدف العمل",
      workTarget: "هدف العمل",
      workAim: "غرض العمل",
      workIntention: "نية العمل",
      workPlan: "خطة العمل",
      workStrategy: "استراتيجية العمل",
      workTactic: "تكتيك العمل",
      workMethod: "طريقة العمل",
      workApproach: "نهج العمل",
      workProcess: "عملية العمل",
      workProcedure: "إجراء العمل",
      workProtocol: "بروتوكول العمل",
      workGuideline: "إرشاد العمل",
      workPolicy: "سياسة العمل",
      workRule: "قاعدة العمل",
      workLaw: "قانون العمل",
      workRegulation: "تنظيم العمل",
      workStandard: "معيار العمل",
      workCriterion: "معيار العمل",
      workBenchmark: "معيار العمل",
      workMetric: "مقياس العمل",
      workIndicator: "مؤشر العمل",
      workParameter: "معامل العمل",
      workVariable: "متغير العمل",
      workFactor: "عامل العمل",
      workElement: "عنصر العمل",
      workComponent: "مكون العمل",
      workPart: "جزء العمل",
      workPiece: "قطعة العمل",
      workUnit: "وحدة العمل",
      workModule: "وحدة العمل",
      workSystem: "نظام العمل",
      workStructure: "هيكل العمل",
      workFramework: "إطار العمل",
      workArchitecture: "هندسة العمل",
      workDesign: "تصميم العمل",
      workLayout: "تخطيط العمل",
      workArrangement: "ترتيب العمل",
      workOrganization: "تنظيم العمل",
      workManagement: "إدارة العمل",
      workAdministration: "إدارة العمل",
      workGovernance: "حوكمة العمل",
      workControl: "تحكم العمل",
      workDirection: "توجيه العمل",
      workGuidance: "إرشاد العمل",
      workLeadership: "قيادة العمل",
      workSupervision: "إشراف العمل",
      workOversight: "إشراف العمل",
      workMonitoring: "مراقبة العمل",
      workTracking: "تتبع العمل",
      workFollowing: "متابعة العمل",
      workPursuing: "متابعة العمل",
      workChasing: "متابعة العمل",
      workHunting: "متابعة العمل",
      workSeeking: "بحث العمل",
      workSearching: "بحث العمل",
      workLooking: "بحث العمل",
      workFinding: "إيجاد العمل",
      workDiscovering: "اكتشاف العمل",
      workUncovering: "كشف العمل",
      workRevealing: "كشف العمل",
      workExposing: "كشف العمل",
      workShowing: "عرض العمل",
      workDisplaying: "عرض العمل",
      workPresenting: "عرض العمل",
      workDemonstrating: "إظهار العمل",
      workIllustrating: "توضيح العمل",
      workExplaining: "شرح العمل",
      workClarifying: "توضيح العمل",
      workElucidating: "توضيح العمل",
      workExpounding: "شرح العمل",
      workExpressing: "التعبير عن العمل",
      workConveying: "نقل العمل",
      workCommunicating: "تواصل العمل",
      workTransmitting: "نقل العمل",
      workTransferring: "نقل العمل",
      workMoving: "تحريك العمل",
      workShifting: "تحريك العمل",
      workChanging: "تغيير العمل",
      workAltering: "تغيير العمل",
      workModifying: "تعديل العمل",
      workAdjusting: "تعديل العمل",
      workAdapting: "تعديل العمل",
      workFitting: "تعديل العمل",
      workSuiting: "تعديل العمل",
      workMatching: "تطابق العمل",
      workAligning: "محاذاة العمل",
      workCoordinating: "تنسيق العمل",
      workIntegrating: "تكامل العمل",
      workUnifying: "توحيد العمل",
      workConsolidating: "توحيد العمل",
      workCombining: "دمج العمل",
      workMerging: "دمج العمل",
      workFusing: "دمج العمل",
      workBlending: "مزج العمل",
      workMixing: "مزج العمل",
      workMingling: "مزج العمل",
      workIntermingling: "مزج العمل",
      workInterweaving: "مزج العمل",
      workInterlacing: "مزج العمل",
      workInterlocking: "مزج العمل",
      workInterconnecting: "ربط العمل",
      workLinking: "ربط العمل",
      workConnecting: "ربط العمل",
      workJoining: "ربط العمل",
      workUniting: "توحيد العمل",
      workBonding: "ربط العمل",
      workAttaching: "ربط العمل",
      workAffixing: "ربط العمل",
      workFastening: "ربط العمل",
      workSecuring: "تأمين العمل",
      workFixing: "تثبيت العمل",
      workSetting: "تثبيت العمل",
      workPlacing: "وضع العمل",
      workPositioning: "وضع العمل",
      workLocating: "تحديد موقع العمل",
      workSituating: "وضع العمل",
      workEstablishing: "إنشاء العمل",
      workCreating: "إنشاء العمل",
      workForming: "تشكيل العمل",
      workShaping: "تشكيل العمل",
      workMolding: "تشكيل العمل",
      workCasting: "تشكيل العمل",
      workForging: "تشكيل العمل",
      workCrafting: "تشكيل العمل",
      workMaking: "صنع العمل",
      workBuilding: "بناء العمل",
      workConstructing: "بناء العمل",
      workErecting: "بناء العمل",
      workRaising: "رفع العمل",
      workLifting: "رفع العمل",
      workElevating: "رفع العمل",
      workUplifting: "رفع العمل",
      workUpgrading: "ترقية العمل",
      workImproving: "تحسين العمل",
      workEnhancing: "تحسين العمل",
      workBetterment: "تحسين العمل",
      workAdvancement: "تقدم العمل",
      workDevelopment: "تطوير العمل",
      workEvolution: "تطور العمل",
      workGrowth: "نمو العمل",
      workExpansion: "توسع العمل",
      workExtension: "توسع العمل",
      workEnlargement: "توسع العمل",
      workIncrease: "زيادة العمل",
      workMultiplication: "تكاثر العمل",
      workProliferation: "تكاثر العمل",
      workPropagation: "تكاثر العمل",
      workSpreading: "انتشار العمل",
      workDiffusion: "انتشار العمل",
      workDissemination: "انتشار العمل",
      workDistribution: "توزيع العمل",
      workDispersion: "توزيع العمل",
      workScattering: "توزيع العمل",
      workDispersal: "توزيع العمل",
      workDisplacement: "نقل العمل",
      workRelocation: "نقل العمل",
      workTransfer: "نقل العمل",
      workMovement: "حركة العمل",
      workMotion: "حركة العمل",
      workAction: "فعل العمل",
      workActivity: "نشاط العمل",
      workOperation: "عملية العمل",
      workFunction: "وظيفة العمل",
      workRole: "دور العمل",
      workPart: "جزء العمل",
      workComponent: "مكون العمل",
      workElement: "عنصر العمل",
      workFactor: "عامل العمل",
      workVariable: "متغير العمل",
      workParameter: "معامل العمل",
      workIndicator: "مؤشر العمل",
      workMetric: "مقياس العمل",
      workBenchmark: "معيار العمل",
      workCriterion: "معيار العمل",
      workStandard: "معيار العمل",
      workRegulation: "تنظيم العمل",
      workRule: "قاعدة العمل",
      workLaw: "قانون العمل",
      workPolicy: "سياسة العمل",
      workGuideline: "إرشاد العمل",
      workProtocol: "بروتوكول العمل",
      workProcedure: "إجراء العمل",
      workProcess: "عملية العمل",
      workApproach: "نهج العمل",
      workMethod: "طريقة العمل",
      workTactic: "تكتيك العمل",
      workStrategy: "استراتيجية العمل",
      workPlan: "خطة العمل",
      workIntention: "نية العمل",
      workAim: "غرض العمل",
      workTarget: "هدف العمل",
      workObjective: "هدف العمل",
      workGoal: "هدف العمل",
      workPurpose: "غرض العمل",
      workMission: "مهمة العمل",
      workVision: "رؤية العمل",
      workInsight: "بصيرة العمل",
      workUnderstanding: "فهم العمل",
      workKnowledge: "معرفة العمل",
      workWisdom: "حكمة العمل",
      workTruth: "حقيقة العمل",
      workReality: "واقع العمل",
      workExistence: "وجود العمل",
      workUniverse: "كون العمل",
      workWorld: "عالم العمل",
      workSociety: "مجتمع العمل",
      workPublic: "عامة العمل",
      workAudience: "جمهور العمل",
      workBeneficiaries: "مستفيدي العمل",
      workUsers: "مستخدمي العمل",
      workCustomers: "عملاء العمل",
      workStakeholders: "أصحاب المصلحة في العمل",
      workCommunity: "مجتمع العمل",
      workNetwork: "شبكة العمل",
      workAlliance: "تحالف العمل",
      workCollaboration: "تعاون العمل",
      workPartnership: "شراكة العمل",
      workSponsorship: "رعاية العمل",
      workFunding: "تمويل العمل",
      workFinance: "تمويل العمل",
      workBudget: "ميزانية العمل",
      workCost: "تكلفة العمل",
      workInvestment: "استثمار العمل",
      workReturn: "عائد العمل",
      workValue: "قيمة العمل",
      workBenefits: "فوائد العمل",
      workImpacts: "تأثيرات العمل",
      workOutcomes: "مخرجات العمل",
      workResults: "نتائج العمل",
      workPerformance: "أداء العمل",
      workProductivity: "إنتاجية العمل",
      workEffectiveness: "فعالية العمل",
      workEfficiency: "كفاءة العمل",
      workOptimization: "تحسين العمل",
      workIntegration: "تكامل العمل",
      workCoordination: "تنسيق العمل",
      workCommunication: "تواصل العمل",
      workTeamwork: "عمل الفريق",
      workLeadership: "قيادة العمل",
      workExcellence: "تميز العمل",
      workInnovation: "ابتكار العمل",
      workSustainability: "استدامة العمل",
      workEnvironment: "بيئة العمل",
      workSafety: "سلامة العمل",
      workQuality: "جودة العمل",
      workRating: "تقييم العمل",
      workFeedback: "ملاحظات العمل",
      workImprovements: "تحسينات العمل",
      workLessons: "دروس العمل",
      workRecommendations: "توصيات العمل",
      workSolutions: "حلول العمل",
      workIssues: "مشاكل العمل",
      workRisks: "مخاطر العمل",
      workMilestones: "معالم العمل",
      workSchedule: "جدول العمل",
      workPersonnel: "موظفي العمل",
      workEquipment: "معدات العمل",
      workMaterials: "مواد العمل",
      workSpecifications: "مواصفات العمل",
      workDrawings: "رسومات العمل",
      workPhotos: "صور العمل",
      workReports: "تقارير العمل",
      workInspections: "فحوصات العمل",
      workPermits: "تصاريح العمل",
      workContracts: "عقود العمل",
      workInvoices: "فواتير العمل",
      workPayments: "مدفوعات العمل",
      workCosts: "تكاليف العمل",
      workDelays: "تأخيرات العمل",
      workChanges: "تغييرات العمل",
      workRejections: "رفض العمل",
      workApprovals: "موافقات العمل",
      workComments: "تعليقات العمل",
      workHistory: "سجل العمل",
      workAttachments: "مرفقات العمل",
      workNotes: "ملاحظات العمل",
      workProgress: "تقدم العمل",
      workStatus: "حالة العمل",
      workScope: "نطاق العمل",
      workLocation: "موقع العمل",
      workOrderType: "نوع أمر العمل",
      id: "المعرف",
      createdAt: "تاريخ الإنشاء",
      updatedAt: "تاريخ التحديث",
    };

    return keyMap[key] || key;
  };

  // Helper function to format values for display
  const formatValue = (key, value) => {
    if (value === null || value === undefined) return "-";

    // Format dates
    if (
      key === "createAt" ||
      key === "completionDate" ||
      key === "createdAt" ||
      key === "updatedAt"
    ) {
      const date = new Date(value);
      return date.toLocaleDateString("ar-SA");
    }

    // Format duration
    if (key === "durationOfImplementation") {
      return `${value} يوم`;
    }

    // Format estimated value
    if (key === "estimatedValue") {
      return `${value} ريال`;
    }

    // Format project type
    if (key === "projectType") {
      const projectTypes = {
        rehabilitationWorks: "أعمال إعادة التأهيل",
        constructionProjects: "مشاريع البناء",
        emergencyProjects: "المشاريع الطارئة",
        maintainProjects: "مشاريع الصيانة",
      };
      return projectTypes[value] || value;
    }

    // Format situation
    if (key === "situation") {
      const situations = {
        "قيد التنفيذ": "قيد التنفيذ",
        "تم التنفيذ": "تم التنفيذ",
        معلق: "معلق",
        ملغي: "ملغي",
        "لا يحتاج تصريح": "لا يحتاج تصريح",
      };
      return situations[value] || value;
    }

    // Format arrays
    if (Array.isArray(value)) {
      if (value.length === 0) return "-";
      return value.join("، ");
    }

    // Format objects
    if (typeof value === "object") {
      return JSON.stringify(value);
    }

    return value;
  };

  // Get status color
  const getStatusColor = (status) => {
    const colors = {
      "قيد التنفيذ": "bg-blue-100 text-blue-800",
      "تم التنفيذ": "bg-green-100 text-green-800",
      معلق: "bg-yellow-100 text-yellow-800",
      ملغي: "bg-red-100 text-red-800",
      "لا يحتاج تصريح": "bg-gray-100 text-gray-800",
    };

    return colors[status] || "bg-gray-100 text-gray-800";
  };

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <div
          className="fixed inset-0 transition-opacity"
          aria-hidden="true"
          onClick={onClose}
        >
          <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>

        <span
          className="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
        >
          &#8203;
        </span>

        <div className="inline-block align-bottom bg-white rounded-lg text-right overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-4xl sm:w-full">
          <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <div className="sm:flex sm:items-start">
              <div className="mt-3 text-center sm:mt-0 sm:text-right w-full">
                <h3 className="text-lg leading-6 font-medium text-gray-900 mb-4">
                  تفاصيل المشروع
                </h3>
                <div className="mt-2 max-h-[70vh] overflow-y-auto">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {Object.entries(data).map(([key, value]) => {
                      // Skip internal fields or empty values
                      if (
                        key.startsWith("_") ||
                        key === "id" ||
                        value === null ||
                        value === undefined ||
                        value === ""
                      )
                        return null;

                      return (
                        <div
                          key={key}
                          className="bg-gray-50 p-3 rounded-lg border border-gray-200"
                        >
                          <div className="font-bold text-gray-700 mb-1">
                            {formatKey(key)}
                          </div>
                          <div className="text-gray-800 break-words">
                            {key === "situation" ? (
                              <span
                                className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${getStatusColor(
                                  value
                                )}`}
                              >
                                {formatValue(key, value)}
                              </span>
                            ) : (
                              formatValue(key, value)
                            )}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <button
              type="button"
              className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:ml-3 sm:w-auto sm:text-sm"
              onClick={onClose}
            >
              إغلاق
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DataViewerModal; 